/**
 * The rich-text stack (TipTap + ProseMirror + y-prosemirror) is the largest part of the app and
 * only needed once a text block, table or to-do exists on screen or is being created. It lives
 * in its own chunk; these helpers load it on demand and expose it synchronously once loaded.
 */

type RichModule = typeof import('./richExtensions');

let loaded: RichModule | null = null;
let loading: Promise<RichModule> | null = null;

export function loadRich(): Promise<RichModule> {
  if (loaded) return Promise.resolve(loaded);
  loading ??= import('./richExtensions').then((m) => {
    loaded = m;
    return m;
  });
  return loading;
}

/** The module if it has already been loaded, else null. */
export function richSync(): RichModule | null {
  return loaded;
}
